import { Injectable } from '@angular/core';

import { ApiService, AppContext, Carrier, Trips } from './../../../shared';

@Injectable()
export class VoyagePartialService {
  constructor(private api: ApiService, public app: AppContext) {
  }

  getSchedules(carrier: Carrier, params: any): Promise<Trips> {
    params['carriers'] = [carrier.id];

    let promise = this.api.getApiClient().then(client => this.callGetSchedules(client, params));

    return promise;
  }

  callGetSchedules(apigClient: any, query: any): Promise<Trips> {
    let params = {};
    let additionalParams = {
      headers: { 'Content-Type': 'application/json' },
      queryParams: query
    };

    return apigClient.tripsGet(params, '', additionalParams)
      .then(this.handleSchedulesResolve.bind(this)).catch(this.handleSchedulesError.bind(this));
  }

  handleSchedulesResolve(result: any): Trips {
    let trips = new Trips(result);

    trips.items.sort((a, b) => {
      let one = new Date(a.arrivalDate);
      let two = new Date(b.arrivalDate);
      return (one < two) ? -1 : (one > two) ? 1 : 0;
    });

    return trips;
  }

  handleSchedulesError(error: any): number {
    return this.api.handleError(error);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/components/voyage-partial/voyage-partial.service.ts